import AlbumContextMenu from './AlbumContextMenu'
import ArtistContextMenu from './ArtistContextMenu'
import TrackContextMenu from './TrackContextMenu'

const ContextMenus = () => {
  return (
    <>
      <TrackContextMenu />
      <AlbumContextMenu />
      <ArtistContextMenu />
    </>
  )
}

export default ContextMenus
